module.exports = __webpack_public_path__ + "static/media/ic_general_multimodal_dark.4b6147a0.svg";